import axios from "axios";
import {usePaging} from "@/modules/reader/book/paging";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";

class MuteRoleAnnotation extends AbstractAnnotations{

    static get TYPE() {
        return "muteRole"
    }

    constructor(builder) {

        super();
        const {pageState, setCurrentPage} = usePaging();
        this.annotations.domPos = builder.domPos;

        if (!this.annotationTypes.includes(MuteRoleAnnotation.TYPE)) {
            this.annotationTypes.push(MuteRoleAnnotation.TYPE);
        }

        this.annotations.isMuteRole = true;

        for (let [key, value] of Object.entries(builder.meta)) {

            if (key === "roleId") {
                super.setAnnotations({[key]: value});
            }
        }

    }

}

export default MuteRoleAnnotation